export enum ProfileStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    SUSPENDED = "SUSPENDED",
    LEAD = "LEAD",
    PROSPECT = "PROSPECT"
}
